import { Pipe, PipeTransform } from '@angular/core';
import { setOrgnizationData } from 'app/global/get-recipient-data';
import { Orgfield } from 'app/main/pages/edit-template/edit-template.dto';
@Pipe({
  name: 'getOrganization'
})
export class GetOrganizationPipe implements PipeTransform {

  transform(orgfields: Orgfield[]) {
    const organization = setOrgnizationData(orgfields, true);
    return organization;
  }

}
